import React, { useRef, useState } from 'react';
import useTranslate from '../../../../common/hooks/useTranslate';

import { IAcceptedAgreementsComponent } from '../../types/IAcceptedAgreementsComponent';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import DateCell from '../../../documents/components/cells/dateCell/dateCell';
import HeaderCell from '../../../documents/components/cells/headerCell/headerCell';
import TableLoading from '../../../ui/loaders/tableLoader/tableLoading';
import AgreementNameCell from './cells/agreementNameCell/agreementNameCell';

import '@progress/kendo-theme-default/dist/all.css';
import '../activityLog/activityLog.scss';
import './acceptedAgreements.scss';

const AcceptedAgreements: React.FC<IAcceptedAgreementsComponent> = ({data, loadingActivity}) => {
  const [sort, setSort] = useState<any>([{ field: 'date', dir: 'desc' }]);
  const { t } = useTranslate();
  const tableRef = useRef(null);

  const AgreementNameCellFc = (props) => <AgreementNameCell {...props} />

  return (
    <div className="table accepted-agreements-wrapper">
      <div className="accepted-agreements-name-wrapper">
        <span className="card-title">{t('AGREEMENT.CARD_TITLE')}</span>
      </div>

      <Grid
        data={data}
        sortable={true}
        sort={sort}
        total={800}
        pageSize={40}
        filterable={true}
        scrollable="scrollable"
        onSortChange={(e) => {
          setSort(e.sort);
        }}
        ref={tableRef}
        selectedField="selected">
        <GridColumn field="agreementName" title={t('AGREEMENT.COLUMN_NAME')} className="tableCell" headerCell={HeaderCell} cell={AgreementNameCellFc} />
        <GridColumn field="date" title={t('AGREEMENT.COLUMN_DATE')} className="tableCell" headerCell={HeaderCell} cell={(props) => <DateCell {...props} />} width={205} />
      </Grid>
      {loadingActivity && <TableLoading tableElement={tableRef} />}
    </div>
  );
};

export default AcceptedAgreements;
